var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('vs-button',{style:({position:'absolute', right: '6px', top: '6px', zIndex: 999}),attrs:{"radius":"","type":"border","icon-pack":"feather","icon":"icon-download","size":"small"},on:{"click":function($event){return _vm.exportData()}}}),_c('i-table',_vm._b({ref:"table"},'i-table',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }